import React from "react";
import Company from "../../components/company/Company";

function CreateCompany() {
  return (
    <div>
      <Company />
    </div>
  );
}

export default CreateCompany;
